import type { PaginationMeta } from '@/components/ui/Pagination';

export function paginateClient<T>(
  items: T[],
  page: number,
  perPage: number,
  search: string,
  searchFn: (item: T, query: string) => boolean,
): { data: T[]; meta: PaginationMeta } {
  const filtered = search
    ? items.filter((item) => searchFn(item, search.toLowerCase()))
    : items;
  const total = filtered.length;
  const last_page = Math.max(1, Math.ceil(total / perPage));
  const current_page = Math.min(Math.max(1, page), last_page);
  const start = (current_page - 1) * perPage;
  const data = filtered.slice(start, start + perPage);

  return {
    data,
    meta: {
      current_page,
      last_page,
      per_page: perPage,
      total,
      from: total ? start + 1 : 0,
      to: Math.min(start + perPage, total),
    },
  };
}
